import { getDayJs } from '~/services/TimeService';

import { LereToursPricingSuggestion, PriceDirection, SuggestedActionType } from '../types';

export const SUGGESTED_ACTION_TYPE_OPTIONS: Array<{ value: SuggestedActionType; label: string }> = [
  { value: 'surcharge', label: 'Surcharge' },
  { value: 'discount', label: 'Discount' },
];

export const PRICE_DIRECTION_OPTIONS: Array<{ value: PriceDirection; label: string }> = [
  { value: 'surcharge', label: 'Surcharge From Current Price' },
  { value: 'discount', label: 'Discount From Current Price' },
  { value: 'none', label: 'No Change From Current Price' },
];

export function getPriceDirection(row: LereToursPricingSuggestion): PriceDirection {
  if (row.price_direction) {
    return row.price_direction;
  }
  const current = row.current_tour_price ?? row.original_tour_price;
  const difference = row.suggested_after_price - current;
  return difference > 0.005 ? 'surcharge' : difference < -0.005 ? 'discount' : 'none';
}

export function getPriceDirectionLabel(direction: PriceDirection): string {
  return PRICE_DIRECTION_OPTIONS.find((option) => option.value === direction)?.label ?? 'No Change From Current Price';
}

export function formatDate(value: string | null): string {
  if (!value) {
    return '—';
  }
  const parsed = getDayJs(value);
  return parsed.isValid() ? parsed.format('DD/MM/YYYY') : value;
}

export function formatDateTime(value: string | null): string {
  if (!value) {
    return '—';
  }
  const parsed = getDayJs(value);
  return parsed.isValid() ? parsed.format('DD/MM/YYYY HH:mm') : value;
}

export function getTourOfferHref(offerBk: string | null | undefined, offerUrl?: string | null): string | null {
  if (offerUrl) {
    return offerUrl;
  }
  const trimmedOfferBk = offerBk?.trim();
  if (!trimmedOfferBk) {
    return null;
  }
  return `${window.location.origin}/tours/details/tour-${trimmedOfferBk}`;
}

export function formatCurrency(value: number | null): string {
  if (value == null) {
    return '—';
  }
  return `$${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatSignedPercent(value: number | null): string {
  if (value == null) {
    return '—';
  }
  const prefix = value > 0 ? '+' : '';
  return `${prefix}${(value * 100).toFixed(1)}%`;
}

export function formatSignedCurrency(value: number | null): string {
  if (value == null) {
    return '—';
  }
  const prefix = value > 0 ? '+' : '';
  return `${prefix}$${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function getChangeColor(actionType: string): string {
  if (actionType === 'surcharge') {
    return 'success.main';
  }
  if (actionType === 'discount') {
    return 'error.main';
  }
  return 'text.primary';
}

export function getStatusColor(status: string): 'success' | 'error' | 'default' {
  if (status === 'accepted') {
    return 'success';
  }
  if (status === 'rejected') {
    return 'error';
  }
  return 'default';
}

export function capitalizeFirst(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}
